
import { useState } from "react";
import { FiX, FiCheck } from "react-icons/fi";

const CATEGORY_OPTIONS = [
  "Spice Blends VRAC",
  "Spice Blends Custom VRAC",
  "Spices Bulk VRAC",
  "Spices Bulk 1 KG",
  "Spices Bulk 2.5 KG",
  "Spices Bulk 5 KG",
  "Spices Bulk 10 KG",
  "Spices Bulk 25 KG (MASTER)",
  "Spices Custom 5 KG",
  "Spices Custom 25 KG (MASTER)",
];

const FORM_FIELDS = [
  ["category", "Category", "dropdown"],
  ["grossMarginPercent", "Gross Margin %", "number"],
  ["webPercent", "Web %", "number"],
  ["wholesale1Percent", "Wholesale 1 %", "number"],
  ["wholesale2Percent", "Wholesale 2 %", "number"],
  ["distributorPercent", "Distributor %", "number"],
  ["exportPercent", "Export %", "number"],
  ["exportMenaPercent", "Export MENA %", "number"],
];

/* 🔽 Custom Dropdown */
function CategoryDropdown({ value, onChange, disabled }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      {/* Selected */}
      <div
        onClick={() => !disabled && setOpen(!open)}
        className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm text-gray-900 bg-white cursor-pointer"
      >
        {value || "Select category"}
      </div>

      {/* Dropdown */}
      {open && (
        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-xl shadow-lg">
          <div className="max-h-[120px] overflow-y-auto no-scrollbar">
            {CATEGORY_OPTIONS.map((opt) => (
              <div
                key={opt}
                onClick={() => {
                  onChange(opt);
                  setOpen(false);
                }}
                className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
              >
                {opt}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default function BulkRuleModal({
  isOpen,
  onClose,
  onSubmit,
  form,
  setForm,
  editingId,
  loading,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h2 className="text-lg font-bold text-gray-900">
            {editingId ? "Edit Bulk Rule" : "Add New Bulk Rule"}
          </h2>
          <button
            onClick={onClose}
            disabled={loading}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-50"
          >
            <FiX className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Fields */}
        <div className="p-6 grid grid-cols-2 gap-4 max-h-[65vh] overflow-y-auto">
          {FORM_FIELDS.map(([key, label, type]) => (
            <div key={key}>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5 uppercase tracking-wide">
                {label}
              </label>

              {type === "dropdown" ? (
                <CategoryDropdown
                  value={form[key]}
                  onChange={(val) => setForm({ ...form, [key]: val })}
                  disabled={loading}
                />
              ) : (
                <input
                  type={type}
                  min={0}
                  value={form[key]}
                  onChange={(e) =>
                    setForm({ ...form, [key]: e.target.value })
                  }
                  disabled={loading}
                  className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm text-gray-900
                    focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent
                    transition disabled:bg-gray-50 disabled:opacity-60"
                  placeholder={label}
                />
              )}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="flex gap-3 px-6 py-4 border-t border-gray-100 bg-gray-50">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium
              text-gray-600 hover:bg-white transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            disabled={loading}
            className="flex-1 px-4 py-2.5 rounded-xl bg-gray-900 text-white text-sm font-medium
              hover:bg-gray-700 transition flex items-center justify-center gap-2 disabled:opacity-60"
          >
            <FiCheck className="w-4 h-4" />
            {loading ? "Saving..." : editingId ? "Update Rule" : "Create Rule"}
          </button>
        </div>
      </div>
    </div>
  );
}
